import { Link } from "react-router-dom";
import { BRAND_ROUTE, CITY_BRAND_ROUTE } from "../../routes/constant";

const BrandCard = ({ brand, isDarkMode, city, categorySlug }) => {
  if (!brand) {
    console.warn("Brand object is undefined");
    return null;
  }

  const getBrandRoute = () => {
    if (city?.slug) {
      return CITY_BRAND_ROUTE(city.slug, categorySlug, brand?.slug);
    }
    return BRAND_ROUTE(categorySlug, brand?.slug);
  };

  return (
    <Link
      to={getBrandRoute()}
      className={`group relative rounded-lg overflow-hidden cursor-pointer transition-all duration-200 ${
        isDarkMode
          ? "bg-gray-800 hover:bg-gray-700"
          : "bg-white shadow-[0_2px_6px_rgba(0,0,0,0.06)] hover:shadow-[0_4px_10px_rgba(0,180,120,0.15)] border border-transparent hover:border-emerald-200"
      }`}
    >
      {/* Brand Image - Compact */}
      <div className="pt-3 pb-0.5 px-2">
        <div className="flex items-center justify-center w-full aspect-square">
          <img
            src={brand?.image}
            alt={brand?.name || "Brand"}
            className="object-contain w-2/3 h-2/3"
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/placeholder-brand.png";
            }}
          />
        </div>
      </div>

      {/* Brand Name - Compact */}
      <div className="px-1 pb-2 text-center">
        <h3
          className={`text-[11px] font-medium truncate ${
            isDarkMode
              ? "text-gray-200"
              : "text-gray-700 group-hover:text-emerald-700"
          }`}
        >
          {brand?.name || "Unknown Brand"}
        </h3>
        {brand?.productCount && (
          <p
            className={`text-[8px] mt-0.5 ${
              isDarkMode
                ? "text-gray-400"
                : "text-gray-400 group-hover:text-emerald-600"
            }`}
          >
            {brand.productCount} products
          </p>
        )}
      </div>

      {/* Green Accent Line */}
      {!isDarkMode && (
        <div className="h-0.5 w-0 group-hover:w-full transition-all duration-300 bg-emerald-400" />
      )}
    </Link>
  );
};

export default BrandCard;